import type { SkillDetail } from '../../types/api'

/**
 * Pure form helpers for the skill editor, kept out of `SkillsPanel.tsx` so
 * that file only exports components (react-refresh) and so the tag parsing is
 * testable without rendering.
 */

/** Editable fields of a skill, as the form holds them (tags comma-joined). */
export interface SkillForm {
  description: string
  content: string
  tags: string
}

export const EMPTY_SKILL_FORM: SkillForm = {
  description: '',
  content: '',
  tags: '',
}

/** The saved skill rendered as form values — the baseline a draft diffs against. */
export function skillToForm(skill: SkillDetail | undefined): SkillForm {
  if (!skill) return EMPTY_SKILL_FORM
  return {
    description: skill.description,
    content: skill.content,
    tags: skill.tags.join(', '),
  }
}

/**
 * Form values as the PATCH body. Tags are split on commas with blanks dropped,
 * so trailing commas and stray whitespace while typing don't produce empty tags.
 */
export function skillFormToUpdateBody(form: SkillForm): {
  description: string
  content: string
  tags: string[]
} {
  return {
    description: form.description,
    content: form.content,
    tags: form.tags
      .split(',')
      .map((t) => t.trim())
      .filter(Boolean),
  }
}
